<template>
    <div>
         <section class="about-us">
    <!-- Page-wrapper-Start -->
    <div class="page_wrapper">
      <!-- Preloader -->
      <!-- <div id="preloader">
        <div id="loader"></div>
      </div> -->
    </div>
    <!-- Page-wrapper-End -->
  </section>
  <!-- App-Solution-Section-Start -->
  <section class="row_am app_solution_section">
    <!-- container start -->
    <div class="container">
      <!-- row start -->
      <div class="row">
        <div class="col-lg-6">
          <!-- UI content -->
          <div class="app_text">
            <div
              class="section_title"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="100"
            >
              <h2>
                <span>Providing innovative app solution</span> to make customer
                life easy to grow.
              </h2>
            </div>
            <p data-aos="fade-up" data-aos-duration="1500">
              Lorem Ipsum is simply dummy text of the printing and type setting
              industry lorem Ipsum has been the industrys standard dummy text
              ever since the when an unknown printer took a galley of type and
              scrambled it to make a type specimen book. It has survived not
              only five centuries, but also the leap into electronic
              typesetting, remaining to make a type speci men book. It has
              survived essentially unchanged.
            </p>
            <p data-aos="fade-up" data-aos-duration="1500">
              Standard dummy text ever since the when an unknown printer took a
              galley of type and scrambled it to make a type specien book. It
              has survived not only five centuries, but also the leap into
              electronic typesetting.
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="app_images" data-aos="fade-in" data-aos-duration="1500">
            <ul>
              <li><img src="images/abt_001.png" alt="" /></li>
              <li><img src="images/abt_002.png" alt="" /></li>
              <li><img src="images/abt_00302.png" alt="" /></li>
            </ul>
          </div>
        </div>
      </div>
      <!-- row end -->
    </div>
    <!-- container end -->
  </section>
  <!-- App-Solution-Section-end -->

 <WhyWeAre/>
  
  
    </div>
</template>
<script setup>

import WhyWeAre from './WhyWeAre.vue';

</script>
<style scoped>

</style>